module.exports = __webpack_public_path__ + "img/q1_op3.fd8fd035.png";